import { RootState } from "../reducers/rootReducer";

export const getLogRequestUserMappingsSelector = (state: RootState) =>
    state.logRequest.logRequestUserMappings;

export const getSelectedLogRequestSelector = (state: RootState) =>
    state.logRequest.selectedLogRequest;

export const getSelectedLogRequestLoadingSelector = (state: RootState) =>
    state.logRequest.selectedLogRequestLoading;
